//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $$ from 'jquery'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import { mapGetters,mapActions,mapState } from 'vuex';
// import {requestByPost} from '@/until/request'
// import {API} from '@/until/api'
// import { Toast, PullRefresh,Empty} from 'vant';
// import { fnSub } from '../../until/base';
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'home',
 data(){
    let that = this
    return {
    value:'',
    active:1,
    activeD:1,
    flagBactive:1,
    flagAactive:1,
    flagCactive:1,
    flagDactive:1,
    showImall:false,
    activeImg:1,
    swiperOptionTop: {
      loop: true,
      loopedSlides: 5,
      spaceBetween: 10,
      touchRatio: 0,
    },
    swiperOptionThumbs: {
      loop: true,
      loopedSlides: 5,
      spaceBetween: 10,
      centeredSlides: false,
      slidesPerView: 3.5,
      touchRatio: .2,
      slideToClickedSlide: true,
      },
      swiperOptionTopF: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        touchRatio: 0,
      },
      swiperOptionThumbsF: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: false,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        on: {
          tap(event) {
            that.swiperF.slideTo(event.activeIndex, 1000, false)
          }
        }
      }
    }
  },
  components:{
    Swiper,
    SwiperSlide,
    Footer,
    Header
  },
  directives: {
    swiper: directive
  },
  computed:{
    swiper() {
      return this.$refs.swiperTop.$swiper
    }
  },
  methods:{
    imgClick(params){
      this.activeImg = params
    },
    flagC(params){
      this.flagCactive = params
    },
    flagA(params){
      this.flagAactive = params
    },
    flagB(params){
      this.flagBactive = params
    },
    flagD(params){
      this.flagDactive = params
    },
    showSwip(){
        this.showImall = true
    },
    close(e){
        if(e.toElement.nodeName =="DIV") this.showImall = false
    },
    addC(params){
        this.active = params
    },
    addD(params){
        this.activeD = params
    },
    btnAIPricing () {
      // 跳转AI智能报价页面
      alert(111);
    }
  },
  mounted(){
    document.title = "找合作"
  },
  created(){

  }
}



// WEBPACK FOOTER //
// ./src/pages/product/product.vue